import { getUid } from "../common";
import { ENV_HW_META_KEYS, ENV_HW_TYPE_MAP, MES_KEY_STAGE, MES_STAGE_MAP } from "../enum";
export async function parseCustomerToEntry(data) {
    const contactInfo = (data.type == "company") ? { email: '', phone: '' } :
        (data.type == "person") ? { email: data.contact ? data.contact.email : '', phone: data.contact ? data.contact.phone : '' } :
            { email: '', phone: '' };
    if (!data.customer_dbUid) {
        console.warn('[WARN parsing]: no dbUid', data);
    }
    return {
        dbUid: (data.customer_dbUid) ? data.customer_dbUid : undefined,
        uid: getUid(),
        // dbUid: (data.dbUid) ? data.dbUid : undefined,
        type: data.type,
        name: data.name,
        contact: contactInfo,
        subElement: !data.subElement ? [] : await Promise.all(data.subElement.map(async (subData) => ({
            ent: await parseCustomerToEntry(subData.ent)
        })))
    };
}
async function parseMesurmentEnv(data) {
    if (!data) {
        return null;
    }
    return {
        wika: await parseEnvHwToEntry(data.wika),
        ethanol: await parseEnvHwToEntry(data.etalon),
        oven: await parseEnvHwToEntry(data.oven),
        location: await parseEnvHwToEntry(data.location),
        userId: data.appUser_id
    };
}
export async function parseMesurmentToEntry(data) {
    const env = await parseMesurmentEnv(data.env);
    const wasInStages = (data.stageMetaList) ? data.stageMetaList.map(sMeta => sMeta.stageId) : [];
    const statusData = {
        key: data.stage,
        val: MES_STAGE_MAP[data.stage],
        metaList: (data.stageMetaList) ? data.stageMetaList.map(sMap => {
            return {
                key: sMap.stageId,
                val: MES_STAGE_MAP[sMap.stageId],
                TS: sMap.TS,
                startTS: sMap.TS,
                endTS: sMap.TS
            };
        }) : []
    };
    if (!data.measurement_dbUid) {
        console.warn('[WARN parsing]: no dbUid', data);
    }
    return {
        uid: data.measurement_dbUid,
        dbUid: data.measurement_dbUid ? data.measurement_dbUid : getUid(),
        static: {
            id: data.id,
            userId: '',
            userEvidenceLabel: data.customerEvidenceLabel,
            orderNote: data.orderNote,
            baseOwnerCom: (data.owner) ? {
                dbUid: data.owner.dbUid,
                name: data.owner.name,
            } : {
                dbUid: undefined,
                name: ''
            },
            baseOwnerUser: (data.ownerEmployee) ? {
                dbUid: data.ownerEmployee.dbUid,
                name: data.ownerEmployee.name,
                email: data.ownerEmployee.contact.email,
                phone: data.ownerEmployee.contact.phone,
            } : {
                dbUid: undefined,
                name: '',
                email: '',
                phone: '',
            },
            baseCustomeCom: (data.customer) ? {
                dbUid: data.customer.dbUid,
                name: data.customer.name,
            } : {
                dbUid: undefined,
                name: ''
            },
            baseCustomeUser: (data.customerEmployee) ? {
                dbUid: data.customerEmployee.dbUid,
                name: data.customerEmployee.name,
                email: data.customerEmployee.contact.email,
                phone: data.customerEmployee.contact.phone,
            } : {
                dbUid: undefined,
                name: '',
                email: '',
                phone: '',
            },
            probe: (data.probe) ? {
                dbUid: data.probe.dbUid,
                id: data.probe.id
            } : {
                dbUid: undefined,
                id: ''
            },
            createdTS: new Date(data.createdTS),
            closedts: data.createdTS ? new Date(data.closedTS) : null,
            targetDataPoints: (data.targetDataPoints) ? data.targetDataPoints.map(dp => ({
                sequenceId: dp.sequenceId,
                state: dp.state,
                temp: dp.value,
                hum: NaN,
            })) : [],
        },
        dinamic: {
            asociatedProtocols: [],
            env: env,
            finish: wasInStages.findIndex(val => val === MES_KEY_STAGE["fin"]) !== -1,
            exported: wasInStages.findIndex(val => val === MES_KEY_STAGE["exp"]) !== -1,
            stage: statusData
        },
        data: {
            mesurment: []
        }
    };
}
export async function parseAppCofigToEntry(data) {
    const ret = {
        mesurmentParam: {
            count: (data.measurementParam_count && data.measurementParam_count > 0) ? data.measurementParam_count : 1,
            interval: (data.measurementParam_interval && data.measurementParam_interval > 0) ? data.measurementParam_interval : 5,
            inactiveTimeToWarn: (data.measurementParam_inactiveTimeBeforeWarning) ? data.measurementParam_inactiveTimeBeforeWarning : 60,
        },
        graphEtanol: {
            maxPointCount: (data.graphEtalonMaxPointCount) ? data.graphEtalonMaxPointCount : 10,
        }
    };
    return ret;
}
export async function parseEnvHwToEntry(data) {
    if (!data)
        return null;
    if (!data.envHw_dbUid) {
        console.warn('[WARN parsing]: no dbUid', data);
    }
    const typeVal = ENV_HW_TYPE_MAP[data.type];
    const metaData = (data.type === ENV_HW_META_KEYS['hwStandart']) ? data.meta : (data.type === ENV_HW_META_KEYS['location']) ? data.meta : null;
    return {
        dbUid: data.envHw_dbUid,
        uid: getUid(),
        name: data.name,
        type: data.type,
        typeVal: typeVal,
        metaData: metaData
    };
}
export async function parseExportDataToEntry(expData, musurment) {
    if (!expData || !musurment)
        return null;
    return {
        mes: musurment,
        data: {
            qr: expData.qrCodeBase64,
            token: expData.token,
            validTs: expData.expirationTS,
        }
    };
}
export function parseEnvHwListToMap(data) {
    const map = {};
    data.forEach(val => {
        if (!(val.type in map)) {
            map[val.type] = [];
        }
        map[val.type].push(val);
    });
    return map;
}
export async function reparseUpdatedMeruemtnDataToEntry(old, data) {
}
